<!--
 * @Author:
 * @LastEditTime: 2022-04-28 16:31:32
 * @Description:
-->
<template>
  <el-card class="h-full">
    <div class="flex mb-20px">
      <el-button size="small" class="ml-0px mr-5px" type="primary" @click="addApiScope()"
        >新增</el-button
      >
    </div>
    <el-table
      stripe
      ref="eltable"
      :height="tableHeight"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
    >
      <el-table-column label="名称" prop="name" sortable></el-table-column>
      <el-table-column label="显示名称" prop="displayName" sortable></el-table-column>
      <el-table-column label="必须" prop="required" sortable>
        <template slot-scope="scope">
          {{ scope.row.required ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="在发现文档中显示" prop="showInDiscoveryDocument" sortable>
        <template slot-scope="scope">
          {{ scope.row.showInDiscoveryDocument ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="启用" prop="enabled" sortable>
        <template slot-scope="scope">
          {{ scope.row.enabled ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="editApi(scope.row)" size="mini">修改</el-button>
          <el-button size="mini" @click="deleteApiScope(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <operate-api-scope-dialog
      v-if="showApiScopeDialog"
      :operateApiScopeProps="operateApiScopeProps"
      :apiScopeForm="apiScopeForm"
      @refreshList="findList"
    ></operate-api-scope-dialog>
  </el-card>
</template>

<script>
import { ApiScopeApi } from '@wiz-api/auth-server'

const apiScopeApi = new ApiScopeApi()

const operateApiScopeDialog = () => {
  return import('../components/apiScope/OperateApiScope')
}
export default {
  name: 'client',
  components: {
    operateApiScopeDialog,
  },
  data() {
    return {
      showApiScopeDialog: false,
      operateApiScopeProps: {
        title: '新增api范围',
        editType: 'create',
        visible: true,
      },
      apiScopeForm: {
        name: '',
        displayName: '',
        description: '',
        userClaims: [],
        enabled: true,
        showInDiscoveryDocument: false,
        emphasize: false,
        required: false,
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sort: {
        type: '',
        sortName: 'creationTime',
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    addApiScope() {
      this.showApiScopeDialog = true
      this.operateApiScopeProps = this.$options.data().operateApiScopeProps
      this.apiScopeForm = this.$options.data().apiScopeForm
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async editApi(row) {
      const [err, res] = await apiScopeApi.get(row.id)
      if (!err) {
        this.apiScopeForm = res
      }
      this.showApiScopeDialog = true
      this.operateApiScopeProps = this.$options.data().operateApiScopeProps
      this.operateApiScopeProps.editType = 'edit'
      this.operateApiScopeProps.title = '编辑api范围'
    },
    async findList() {
      const [err, res] = await apiScopeApi.getList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
    /**
     * @description: 删除api范围
     * @param {*}
     * @return {*}
     */
    deleteApiScope(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await apiScopeApi.callDelete(id)

          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            showClose: true,
            message: '已取消删除',
          })
        })
    },
  },
  created() {
    this.searchList()
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.eltable.doLayout()
    })
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
